var ResourceProxyListClass = (function () {
    function ResourceProxyListClass() {
    }
    return ResourceProxyListClass;
}());
//# sourceMappingURL=ResourceProxyListClass.js.map